/* =========================
   METAFIELDS
========================= */

const materialScores = window.materialScores;
console.log(materialScores.chemical.chem);
/* =========================
   SCORE ENGINE
========================= */
function score(value) {
  if (!value) return 0;

  let v = String(value || "").toLowerCase();
  v = v.replace(/[^a-z\s]/g, " ");

  const rules = [
    { match: "very high", score: 4 },
    { match: "excellent", score: 4 },
    { match: "flexible", score: 4 },
    { match: "yes", score: 4 },
    { match: "very dimensionally stable", score: 4 },
    { match: "fans", score: 4 }, 
    { match: "no requirements", score: 4 },/*enclosure*/
    { match: "not required", score: 4 }, /*adhesion aid*/
    { match: "easy print", score: 4 }, /*printability*/

    { match: "high", score: 3 },
    { match: "good", score: 3 },
    { match: "durable", score: 3 },
    { match: "recommended", score: 3 },
    { match: "intermediate", score: 3 },
    { match: "stable", score: 3 },

    { match: "medium", score: 2 },
    { match: "fair", score: 2 },
    { match: "moderate", score: 2 },
    { match: "advanced", score: 2 },
    { match: "med", score: 2 },
    { match: "stiff", score: 2 },
    { match: "enclosed", score: 2 },
    { match: "Prone to Warping or Shrinking", score: 2 }, 

    { match: "low", score: 1 },
    { match: "poor", score: 1 },
    { match: "none", score: 1 },
    { match: "not applicable", score: 1 }, 
    { match: "not resistant", score: 1 }, 
    { match: "Prone to Warping and Shrinking", score: 1 }, 
    { match: "heated chamber", score: 1 },
    { match: "consultation required", score: 1 },
    { match: "required", score: 1 }
  ];

  
  for (const r of rules) {
    if (v.includes(r.match)) return r.score;
  }

  return 0;
}


/* =========================
   RADAR DATA
========================= */
function buildRadarData() {
  return [
    (score(materialScores.performance.tensile) +
     score(materialScores.performance.impact) +
     score(materialScores.performance.durability)) / 3,

    score(materialScores.heat.hres),

    (score(materialScores.chemical.chem)),

    (score(materialScores.environmental.uv) +
     score(materialScores.environmental.tempCycle) +
     score(materialScores.environmental.water)) / 3,

    (score(materialScores.dimensional.warping)),

    (score(materialScores.printability.ease) +
     score(materialScores.printability.nozzle) +
     score(materialScores.printability.adhesion) +
     score(materialScores.printability.enclosure)) / 4
  ];
}


/* =========================
   INIT
========================= */
document.addEventListener("DOMContentLoaded", () => {

  

const canvas = document.querySelector(".materialRadar");
const radarWrapper = document.querySelector(".radar-wrapper");

if (!canvas || !radarWrapper) return;

const radarScores = buildRadarData();
const totalScore = radarScores.reduce((sum, value) => sum + value, 0);

if (totalScore < 1) {
  radarWrapper.style.display = "none";
  return;
}
  new Chart(canvas.getContext("2d"), {
    type: "radar",
    data: {
      labels: [
        "Mechanical Properties",
        "Heat Resistance",
        "Chemical Resistance",
        "Environmental Performance",
        "Dimensional Accuracy",
        "Printability"
      ],
      datasets: [{
         label: materialScores.title,
    data: radarScores,
    fill: true
      }]
    },
    options: {
  plugins: {
    tooltip: {
      callbacks: {
        title: function(context) {
          const explanations = {
            "Mechanical Properties": "Strength, toughness, and durability of the material.",
            "Heat Resistance": "Ability to withstand elevated temperatures.",
            "Chemical Resistance": "Resistance to oils, solvents, acids, bases, and moisture.",
            "Environmental Performance": "Performance under UV exposure and temperature changes.",
            "Dimensional Accuracy": "Ability to maintain shape with minimal warping or shrinkage.",
            "Printability": "Ease of printing, including cooling, adhesion, and hardware requirements."
          };

          return explanations[context[0].label];
        }
      }
    }
  },
  scales: {
    r: {
      min: 0,
      max: 4,
      ticks: {
        stepSize: 1
      }
    }
  }
}
  });

});